import React from 'react';
// Utility Packages
import { useFormik } from 'formik';
import * as Yup from 'yup';
// Redux
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { useDispatch } from 'react-redux';
import { applyJobStatus } from '../../redux/actions/jobApplication';

const ChangeAppliedJobStatus = ({ statusData, open, onHide, tableStates }) => {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      comment: ''
    },
    validationSchema: Yup.object().shape(
      statusData?.value?.name === 'Other'
        ? {
            comment: Yup.string()
              .trim()
              .required('This field is required.')
              .min(3, 'Must be at least 3 characters.')
              .max(50, 'Must be 50 characters or less.')
          }
        : {
            comment: Yup.string().trim()
          }
    ),
    onSubmit: (values) => {
      statusData.value.name === 'Other'
        ? dispatch(
            applyJobStatus({
              id: statusData.id,
              Status: statusData.value.code,
              Comment: values.comment,
              tableStates: tableStates
            })
          )
        : dispatch(
            applyJobStatus({
              id: statusData.id,
              Status: statusData.value.code,
              Comment: null,
              tableStates: tableStates
            })
          );
      handleClose();
    }
  });
  const handleClose = () => {
    onHide();
    formik.resetForm();
  };
  const dialogBody = (
    <>
      <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
        <div className="confirm-title" style={{ width: '100%' }}>
          <i className="pi pi-fw pi-exclamation-triangle"></i>
          Are you sure you want to change the status of this job application to &quot;
          {statusData?.value?.name}&quot;?
        </div>
        <div className="form-group-outer mt-3" style={{ width: '100%' }}>
          <div className="custom-form-group " style={{ width: '100%' }}>
            {statusData?.value?.name === 'Other' && (
              <span className="p-float-label full-width">
                <InputTextarea
                  id="comment"
                  rows={2}
                  cols={30}
                  value={formik.values.comment}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={formik.touched.comment && formik.errors.comment ? 'p-invalid' : ''}
                  style={{ width: '100%' }}
                  placeholder="Specify Other"
                />
              </span>
            )}
          </div>
          {formik.touched.comment && formik.errors.comment && (
            <small className="p-error">{formik.errors.comment}</small>
          )}
        </div>
      </form>
    </>
  );
  const dialogFooter = (
    <>
      <Button
        label="Yes"
        icon="pi pi-check"
        autoFocus
        type="button"
        color="primary"
        onClick={formik.handleSubmit}
      />
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => handleClose()}
      />
    </>
  );
  return (
    <div>
      <Dialog
        visible={open}
        onHide={handleClose}
        footer={dialogFooter}
        header="Change Job Application Status">
        {dialogBody}
      </Dialog>
    </div>
  );
};

export default ChangeAppliedJobStatus;
